module.exports = __webpack_public_path__ + "static/media/download.f6738427.jpeg";